export default {
    header: "您已成功登出",
    message: ""
}